import Swal from 'sweetalert2';

export const SwalCustomClass = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    customClass: 'toast--custom--class',
});
